const getOptionsData = (mcqData) => mcqData.get('options');
const isAnswered = (localAnswer) => !!localAnswer;

export {getOptionsData, isAnswered}